import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Segmented } from "antd";
import { useStores } from "../store/stores.js";
import { __ } from "../utils/i18n.js";
/**
 * Bidirectional V1 ↔ V2 switch for the **customer center** (mounted by both
 * `AccountV1Shortcode` and `AccountV2Shortcode`). Visibility is gated by the
 * `accountV1FallbackEnabled` flag (sourced from PHP constant
 * `REAL_COMMERCE_ACCOUNT_V1_FALLBACK_ENABLED` via `Assets::overrideLocalizeScript`).
 * Clicking the inactive option rewrites the URL's `?v=` query param to the
 * other version; the page reloads via the new URL, the matching shortcode
 * boots, and the matching React tree mounts. Hash routes are preserved.
 */ const AccountVersionSwitch = ({ active })=>{
    const { optionStore } = useStores();
    if (!optionStore.others?.accountV1FallbackEnabled) {
        return null;
    }
    const handleChange = (value)=>{
        const next = value === active ? null : value;
        if (!next) {
            return;
        }
        const url = new URL(window.location.href);
        if (next === "v1") {
            // V1 is explicit opt-in via `?v=1`.
            url.searchParams.set("v", "1");
        } else {
            // V2 is the default; drop the param entirely so the URL stays clean.
            url.searchParams.delete("v");
        }
        // Hash carries over with full URL navigation.
        window.location.href = url.toString();
    };
    return /*#__PURE__*/ _jsxs("div", {
        className: "rc-account-version-switch",
        children: [
            /*#__PURE__*/ _jsxs("span", {
                className: "rc-account-version-switch__label",
                children: [
                    __("View"),
                    ": "
                ]
            }),
            /*#__PURE__*/ _jsx(Segmented, {
                size: "small",
                className: "rc-account-version-switch__segmented",
                value: active,
                onChange: handleChange,
                options: [
                    {
                        label: __("Classic"),
                        value: "v1"
                    },
                    {
                        label: __("Current"),
                        value: "v2"
                    }
                ]
            })
        ]
    });
};
export { AccountVersionSwitch };
